import { BlockCircleIcon, CheckCircleIcon, Tooltip } from '@customink/pigment-react';
import { EcmsPortal } from '~/adapters/services/accounts/tax-exemptions-ECMS-old/types';
import { ImpersonateOnlyBanner } from '~/pages/Settings/components/ImpersonateOnlyBanner';
import { LabelValueRow, LabelValueTable } from '~/pages/Settings/components/LabelValueTable';
import { useAuthUser } from '~/contexts/Auth/AuthContext';
import { CopyValueButton } from '~/components/CopyValueButton';
import { format } from 'date-fns';

export function AdminTaxExemptionInfoBox({ portalData }: { portalData?: EcmsPortal | null }) {
    const { impersonated } = useAuthUser();
    if (!impersonated) {
        return null;
    }

    const portalExists = !!portalData;
    const parsedDate = portalExists && format(new Date(portalData.createdAt), 'MMM d, yyyy');
    return (
        <>
            <ImpersonateOnlyBanner sx={{ mb: 3 }} />
            <LabelValueTable>
                <LabelValueRow
                    label="Portal already created?"
                    value={portalExists ? <CheckCircleIcon /> : <BlockCircleIcon />}
                />
                {portalExists && (
                    <LabelValueRow
                        label="Portal link"
                        value={portalData.portalUrl}
                        action={<CopyValueButton valueToCopy={portalData.portalUrl} variant="secondary" />}
                    />
                )}
                {portalExists && (
                    <LabelValueRow
                        label="Portal creation date"
                        value={
                            <Tooltip title={portalData.createdAt}>
                                <span>{parsedDate}</span>
                            </Tooltip>
                        }
                        action={<CopyValueButton valueToCopy={parsedDate as string} variant="secondary" />}
                    />
                )}
            </LabelValueTable>
        </>
    );
}
